// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__936O7","modal":"Modal_modal__m578v","slide-down":"Modal_slide-down__zfCcg"};